export default __webpack_public_path__ + "static/pic_nomad-7856860fe292ffc28199cba6fb5f8ef4.svg";